import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, change } from "redux-form";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import FormTextField from "../../form/redux-form/NativeFormTextField";
import { signInFormValidation } from "../../../models/auth/AuthModelValidation";
import "./SignInFormStyles.scss";

let SignInForm = ({ handleSubmit, submitting, dispatch, onSubmit }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const onHandleSubmit = useCallback(
    async (formValues) => {
      if (!executeRecaptcha) {
        return;
      }

      try {
        const token = await executeRecaptcha("loginByAdmin");
        dispatch(change("signIn", "recaptchaToken", token));
        onSubmit({ ...formValues, recaptchaToken: token });
      } catch (err) {
        console.error("reCAPTCHA execution failed", err);
      }
    },
    [dispatch, executeRecaptcha, onSubmit],
  );

  return (
    <>
      <h2>Logowanie</h2>
      <form onSubmit={handleSubmit(onHandleSubmit)}>
        <div className="form-group">
          <Field
            name="email"
            type="email"
            component={FormTextField}
            label="Email"
          />
        </div>
        <div className="form-group">
          <Field
            name="password"
            type="password"
            component={FormTextField}
            label="Hasło"
          />
        </div>
        <Field name="recaptchaToken" component="input" type="hidden" />
        <button type="submit" className="btn btn-default" disabled={submitting}>
          {submitting ? "Logowanie..." : "Zaloguj"}
        </button>
        <hr />
      </form>
    </>
  );
};

SignInForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

SignInForm = reduxForm({
  form: "signIn",
  validate: signInFormValidation,
})(SignInForm);

export default SignInForm;
